export default __webpack_public_path__ + "static/media/Path_46.23f594e4.png";